import Layout from '@/layout/layout'

export default {
    path: '/payment',
    component: Layout,
    redirect: 'noRedirect',
    name: '账单管理',
    children: [
        {
            path: 'payBills',
            component: () => import('@/views/payment/PayBills/index'),
            name: '支付账单',
            meta: {title: '支付账单', noCache: true}
        },
        {
            path: 'Collectiondetails',
            component: () => import('@/views/payment/Collectiondetails/Collectiondetails'),
            name: '账单明细',
            meta: {title: '账单明细', noCache: true}
        },
        {
            path: 'redenvelope',
            component: () => import('@/views/payment/Redenvelope/redenvelopeHome'),
            name: '红包统计',
            meta: {title: '红包统计', noCache: true}
        },
        {
            path: 'renewAccountBill',
            component: () => import('@/views/payment/renewAccountBill/index'),
            name: '换新账户账单',
            meta: {title: '换新账户账单', noCache: true}
        },
        {
            path: 'paySet',
            component: () => import('@/views/payment/PayApply/paySet/index'),
            name: '回收业务配置',
            meta: {title: '回收业务配置', noCache: true}
        }
    ]
}
